import React from 'react';
import { Tooltip } from 'react-tooltip';
import { SegmentItem } from '../../types/segmentedItem';
import { InsightType } from '../../queryFunctions/fetchInsightsByType';
import { convertValueToUSD } from '../../../../helpers/currency.helper';

interface CandleStickBarChartProps {
  segmentedItems: SegmentItem[];
  originInsightType: string;
  tooltipTitle?: string;
}

export const SingleBarChart = ({ segmentedItems, originInsightType, tooltipTitle }: CandleStickBarChartProps) => {
  const maxVal = Math.max(...segmentedItems.map((item) => item.total));
  const maxDivHeight = 125; // Maximum height of the divs in pixels
  const minDivHeight = 5;
  const barWidth = segmentedItems?.length === 3 ? '10px' : '4px';

  const getHeight = (value: number) => {
    if (value === 0) {
      return { height: '4px', width: barWidth };
    }

    if (value > 0 && value < 10) {
      return { height: `${minDivHeight}px`, width: barWidth };
    }

    return { height: `${value}px`, width: barWidth };
  };

  return (
    <div className='mb-[10px]' data-testid='SingleBarChart__wrapper'>
      <div className='flex flex-row items-end justify-evenly rounded-lg'>
        {segmentedItems.map((item: SegmentItem) => {
          const expenseHeight = maxVal !== 0 ? (item.total / maxVal) * maxDivHeight : 0;
          return (
            <div
              key={item.title}
              className='flex flex-col items-center p-1 hover:bg-bw02 select-mont-btn'
              data-testid={`SingleBarChart__SegmentedItemWrapper__${item.title}`}
              id={`tooltip-${originInsightType}-${item.title}`}
            >
              <Tooltip anchorSelect={`#tooltip-${originInsightType}-${item.title}`} place='top'>
                <ul className='text-left font-metricR text-[12px]'>
                  <li>
                    <span
                      className='text-bw03'
                      data-testid={`SingleBarChart__SegmentedItem__${item.title}__tooltip-title`}
                    >
                      {tooltipTitle || item.title}
                      :
                      {' '}
                    </span>
                    <span
                      className='text-bw00'
                      data-testid={`SingleBarChart__SegmentedItem__${item.title}__tooltip-amount`}
                    >
                      {`${convertValueToUSD(item.total, 2)}`}
                    </span>
                  </li>
                </ul>
              </Tooltip>

              <div className='flex '>
                <div
                  data-testid={`SingleBarChart__SegmentedItem__${item.title}`}
                  className={`self-end w-[4px] h-[100px] rounded-lg mr-[2px] ${item.total === 0 ? 'bg-bw04' : `${originInsightType === InsightType.Expenses ? 'bg-action03' : 'bg-action02'}`}`}
                  style={getHeight(expenseHeight)}
                />
              </div>
              <div
                className='text-[11px] font-metric hover:font-metricRSemibold'
                data-testid={`SingleBarChart__SegmentedItemTitle__${item.title}`}
              >
                {item.title}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
